import { useEffect, useState } from 'react';
import { FiMapPin } from 'react-icons/fi';
import type { CollaboratorFilters } from '../../api/media';

const USER_TYPE_OPTIONS = [
  { value: 'artist', label: 'Artist' },
  { value: 'dj', label: 'DJ' },
  { value: 'event_producer', label: 'Event Producer' },
  { value: 'venue', label: 'Venue' },
  { value: 'crew', label: 'Crew' },
];

/** Debounces a value so typing doesn't fire a request per keystroke. */
export function useDebouncedValue<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}

interface CollaboratorFilterBarProps {
  userType: string;
  city: string;
  onUserTypeChange: (value: string) => void;
  onCityChange: (value: string) => void;
}

export const CollaboratorFilterBar = ({
  userType,
  city,
  onUserTypeChange,
  onCityChange,
}: CollaboratorFilterBarProps) => (
  <div className="flex flex-col sm:flex-row gap-3">
    <select
      value={userType}
      onChange={(e) => onUserTypeChange(e.target.value)}
      className="flex-1 px-4 py-3 rounded-2xl bg-zinc-900 border border-white/10 text-white focus:outline-none focus:border-blue-500/60 text-[14px]"
    >
      <option value="">All user types</option>
      {USER_TYPE_OPTIONS.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
    <div className="relative flex-1">
      <FiMapPin size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-zinc-500" />
      <input
        type="text"
        value={city}
        onChange={(e) => onCityChange(e.target.value)}
        placeholder="Filter by city"
        className="w-full pl-10 pr-4 py-3 rounded-2xl bg-zinc-900 border border-white/10 text-white placeholder:text-zinc-600 focus:outline-none focus:border-blue-500/60 text-[14px]"
      />
    </div>
  </div>
);

export type { CollaboratorFilters };
